/**
  * `PM_ONSITE` is for payment at the delivery location.
  * It is typically a payment method provided by the courier. For example
  * cash, POS terminal, or even a courier mobile app/link.
  */
export const PM_ONSITE = 'onsite';
/** `PM_COD` is the internal checkout identifier for cash-on-delivery (mapped from `PM_ONSITE`). */
export const PM_COD = 'cod';
/** `PM_ONLINE_CREDIT_CARD` is paying right now with a card. */
export const PM_ONLINE_CREDIT_CARD = 'onlineCreditCard';
/** `PM_ONLINE` is the API response type for online credit card payment in the checkout payment object. */
export const PM_ONLINE = 'online';
/** `PM_CREDIT` is paying with credit for example at Cetelem/Cofidis. */
export const PM_CREDIT = 'credit';
